import React from "react";

const QRScan = React.forwardRef(
  (
    {
      width = "228",
      height = "102",
      viewBox = "0 0 228 102",
      fill = "none",
      fillColor = "white",
      className,
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1332_135)">
          <path
            d="M0 8C0 3.58172 3.58172 0 8 0H220C224.418 0 228 3.58172 228 8V94C228 98.4183 224.418 102 220 102H8C3.58172 102 0 98.4183 0 94V8Z"
            fill="#F9FAFB"
          />
          <rect width="54" height="54" transform="translate(87 24)" fill="white" />
          <path d="M103.054 26.9189H101.595V28.3784H103.054V26.9189Z" fill="black" />
          <path d="M107.432 26.9189H105.973V28.3784H107.432V26.9189Z" fill="black" />
          <path d="M108.892 26.9189H107.432V28.3784H108.892V26.9189Z" fill="black" />
          <path d="M110.351 26.9189H108.892V28.3784H110.351V26.9189Z" fill="black" />
          <path d="M113.27 26.9189H111.811V28.3784H113.27V26.9189Z" fill="black" />
          <path d="M117.649 26.9189H116.189V28.3784H117.649V26.9189Z" fill="black" />
          <path d="M124.946 26.9189H123.487V28.3784H124.946V26.9189Z" fill="black" />
          <path
            d="M104.514 28.3785L103.054 28.3784L103.054 29.8379H104.514V28.3785Z"
            fill="black"
          />
          <path
            d="M105.973 28.3784L104.514 28.3785V29.8379H105.973L105.973 28.3784Z"
            fill="black"
          />
          <path d="M107.432 28.3784H105.973L105.973 29.8379H107.432V28.3784Z" fill="black" />
          <path d="M108.892 28.3784H107.432V29.8379H108.892V28.3784Z" fill="black" />
          <path d="M110.351 28.3784H108.892V29.8379H110.351V28.3784Z" fill="black" />
          <path d="M111.811 28.3784H110.351V29.8379H111.811L111.811 28.3784Z" fill="black" />
          <path d="M117.649 28.3784H116.189V29.8379H117.649V28.3784Z" fill="black" />
          <path d="M119.108 28.3785L117.649 28.3784V29.8379H119.108V28.3785Z" fill="black" />
          <path d="M105.973 29.8379H104.514L104.514 31.2975H105.973V29.8379Z" fill="black" />
          <path d="M108.892 29.8379H107.432L107.432 31.2975H108.892V29.8379Z" fill="black" />
          <path d="M111.811 29.8379H110.351L110.351 31.2975H111.811V29.8379Z" fill="black" />
          <path d="M113.27 29.838L111.811 29.8379V31.2975H113.27V29.838Z" fill="black" />
          <path d="M114.73 29.838H113.27V31.2975H114.73V29.838Z" fill="black" />
          <path d="M116.189 29.8379L114.73 29.838V31.2975H116.189L116.189 29.8379Z" fill="black" />
          <path d="M117.649 29.8379H116.189L116.189 31.2975H117.649V29.8379Z" fill="black" />
          <path d="M119.108 29.8379H117.649V31.2975H119.108V29.8379Z" fill="black" />
          <path d="M122.027 29.838H120.568V31.2975H122.027V29.838Z" fill="black" />
          <path d="M124.946 29.838H123.487V31.2975H124.946V29.838Z" fill="black" />
          <path d="M103.054 31.2978H101.595V32.7572H103.054V31.2978Z" fill="black" />
          <path
            d="M104.514 31.2975L103.054 31.2978V32.7572H104.514L104.514 31.2975Z"
            fill="black"
          />
          <path
            d="M107.432 31.2975H105.973L105.973 32.7572H107.433L107.432 31.2975Z"
            fill="black"
          />
          <path
            d="M108.892 31.2975H107.432L107.433 32.7572H108.892L108.892 31.2975Z"
            fill="black"
          />
          <path d="M114.73 31.2975H113.27L113.27 32.7572H114.73L114.73 31.2975Z" fill="black" />
          <path d="M116.189 31.2975H114.73L114.73 32.7572H116.189L116.189 31.2975Z" fill="black" />
          <path
            d="M122.027 31.2975H120.568L120.568 32.7572H122.027L122.027 31.2975Z"
            fill="black"
          />
          <path
            d="M123.487 31.2975H122.027L122.027 32.7572H123.487L123.487 31.2975Z"
            fill="black"
          />
          <path d="M103.054 32.7566H101.595V34.216H103.054V32.7566Z" fill="black" />
          <path d="M104.514 32.7566H103.054V34.216H104.514V32.7566Z" fill="black" />
          <path d="M114.73 32.7566H113.27V34.216H114.73V32.7566Z" fill="black" />
          <path d="M116.189 32.7566H114.73V34.216H116.189V32.7566Z" fill="black" />
          <path d="M119.108 32.7566H117.649V34.216H119.108V32.7566Z" fill="black" />
          <path d="M122.027 32.7566H120.568V34.216H122.027V32.7566Z" fill="black" />
          <path d="M123.487 32.7566H122.027V34.216H123.487V32.7566Z" fill="black" />
          <path d="M103.054 34.216H101.595L101.595 35.6757H103.054L103.054 34.216Z" fill="black" />
          <path d="M104.514 34.216H103.054L103.054 35.6757H104.514L104.514 34.216Z" fill="black" />
          <path d="M105.973 34.2163L104.514 34.216L104.514 35.6757H105.973V34.2163Z" fill="black" />
          <path d="M108.892 34.2163H107.433V35.6757H108.892V34.2163Z" fill="black" />
          <path d="M113.27 34.216L111.811 34.2163V35.6757H113.27L113.27 34.216Z" fill="black" />
          <path d="M116.189 34.216H114.73L114.73 35.6757H116.189L116.189 34.216Z" fill="black" />
          <path d="M120.568 34.216H119.108L119.108 35.6757H120.567L120.568 34.216Z" fill="black" />
          <path d="M122.027 34.216H120.568L120.567 35.6757H122.027L122.027 34.216Z" fill="black" />
          <path d="M123.487 34.216H122.027L122.027 35.6757H123.487L123.487 34.216Z" fill="black" />
          <path d="M124.946 34.2163L123.487 34.216L123.487 35.6757H124.946V34.2163Z" fill="black" />
          <path d="M126.405 34.2163H124.946V35.6757H126.405V34.2163Z" fill="black" />
          <path d="M103.054 35.6757H101.595V37.135H103.054V35.6757Z" fill="black" />
          <path d="M105.973 35.6757H104.514L104.514 37.135H105.973V35.6757Z" fill="black" />
          <path d="M108.892 35.6757H107.433V37.135H108.892V35.6757Z" fill="black" />
          <path d="M111.811 35.6757L110.351 35.6755V37.135H111.811L111.811 35.6757Z" fill="black" />
          <path d="M114.73 35.6757H113.27L113.27 37.135H114.73L114.73 35.6757Z" fill="black" />
          <path d="M117.649 35.6755L116.189 35.6757L116.189 37.135H117.649V35.6755Z" fill="black" />
          <path d="M120.567 35.6757H119.108V37.135H120.567V35.6757Z" fill="black" />
          <path d="M123.487 35.6757H122.027L122.027 37.135H123.487V35.6757Z" fill="black" />
          <path d="M126.405 35.6757H124.946L124.946 37.135H126.405V35.6757Z" fill="black" />
          <path d="M103.054 37.135H101.595L101.595 38.5947H103.054L103.054 37.135Z" fill="black" />
          <path d="M107.433 37.135H105.973L105.973 38.5947H107.432L107.433 37.135Z" fill="black" />
          <path d="M111.811 37.135H110.351L110.351 38.5947H111.811L111.811 37.135Z" fill="black" />
          <path d="M116.189 37.135H114.73L114.73 38.5947H116.189L116.189 37.135Z" fill="black" />
          <path d="M117.649 37.135H116.189L116.189 38.5947H117.649L117.649 37.135Z" fill="black" />
          <path d="M119.108 37.135H117.649L117.649 38.5947H119.108L119.108 37.135Z" fill="black" />
          <path d="M120.567 37.135H119.108L119.108 38.5947H120.568L120.567 37.135Z" fill="black" />
          <path d="M122.027 37.135H120.567L120.568 38.5947H122.027L122.027 37.135Z" fill="black" />
          <path d="M126.405 37.135H124.946L124.946 38.5947H126.405L126.405 37.135Z" fill="black" />
          <path d="M91.3784 38.5948H89.9189V40.0542H91.3784V38.5948Z" fill="black" />
          <path d="M97.2162 38.5948H95.7568V40.0542H97.2162V38.5948Z" fill="black" />
          <path d="M100.135 38.5948H98.6757V40.0542H100.135V38.5948Z" fill="black" />
          <path
            d="M101.595 38.5947L100.135 38.5948V40.0542H101.595L101.595 38.5947Z"
            fill="black"
          />
          <path d="M103.054 38.5947H101.595L101.595 40.0542H103.054V38.5947Z" fill="black" />
          <path
            d="M105.973 38.5947L104.514 38.5948V40.0542H105.973L105.973 38.5947Z"
            fill="black"
          />
          <path
            d="M108.892 38.5948L107.432 38.5947L107.432 40.0542H108.892V38.5948Z"
            fill="black"
          />
          <path d="M113.27 38.5948L111.811 38.5947L111.811 40.0542H113.27V38.5948Z" fill="black" />
          <path d="M116.189 38.5947H114.73V40.0542H116.189V38.5947Z" fill="black" />
          <path d="M120.568 38.5947H119.108L119.108 40.0542H120.568V38.5947Z" fill="black" />
          <path d="M122.027 38.5947H120.568V40.0542H122.027V38.5947Z" fill="black" />
          <path d="M123.487 38.5948L122.027 38.5947V40.0542H123.487V38.5948Z" fill="black" />
          <path
            d="M124.946 38.5947L123.487 38.5948V40.0542H124.946L124.946 38.5947Z"
            fill="black"
          />
          <path
            d="M127.865 38.5948L126.405 38.5947L126.405 40.0542H127.865V38.5948Z"
            fill="black"
          />
          <path d="M129.324 38.5948H127.865V40.0542H129.324V38.5948Z" fill="black" />
          <path d="M130.784 38.5948H129.324V40.0542H130.784V38.5948Z" fill="black" />
          <path d="M132.243 38.5948H130.784V40.0542H132.243V38.5948Z" fill="black" />
          <path d="M133.703 38.5948H132.243V40.0542H133.703V38.5948Z" fill="black" />
          <path d="M138.081 38.5948H136.622V40.0542H138.081V38.5948Z" fill="black" />
          <path
            d="M92.8379 40.0541L91.3784 40.0542L91.3784 41.5136H92.8379V40.0541Z"
            fill="black"
          />
          <path
            d="M98.6757 40.0542H97.2162L97.2163 41.5136H98.6757L98.6757 40.0542Z"
            fill="black"
          />
          <path
            d="M101.595 40.0542H100.135L100.135 41.5136H101.595L101.595 40.0542Z"
            fill="black"
          />
          <path
            d="M105.973 40.0542H104.514L104.514 41.5136H105.973L105.973 40.0542Z"
            fill="black"
          />
          <path
            d="M107.432 40.0542H105.973L105.973 41.5136H107.433L107.432 40.0542Z"
            fill="black"
          />
          <path d="M113.27 40.0542H111.811L111.811 41.5136H113.27L113.27 40.0542Z" fill="black" />
          <path d="M114.73 40.0542H113.27L113.27 41.5136H114.73L114.73 40.0542Z" fill="black" />
          <path d="M116.189 40.0542H114.73L114.73 41.5136H116.189L116.189 40.0542Z" fill="black" />
          <path
            d="M117.649 40.0541L116.189 40.0542L116.189 41.5136H117.649V40.0541Z"
            fill="black"
          />
          <path
            d="M122.027 40.0542H120.568L120.568 41.5136H122.027L122.027 40.0542Z"
            fill="black"
          />
          <path
            d="M123.487 40.0542H122.027L122.027 41.5136H123.487L123.487 40.0542Z"
            fill="black"
          />
          <path
            d="M124.946 40.0542H123.487L123.487 41.5136H124.946L124.946 40.0542Z"
            fill="black"
          />
          <path
            d="M127.865 40.0542H126.405L126.405 41.5136H127.865L127.865 40.0542Z"
            fill="black"
          />
          <path
            d="M133.703 40.0542H132.243L132.243 41.5136H133.703L133.703 40.0542Z"
            fill="black"
          />
          <path
            d="M135.162 40.0541L133.703 40.0542L133.703 41.5136H135.162V40.0541Z"
            fill="black"
          />
          <path
            d="M138.081 40.0542H136.622L136.622 41.5136H138.081L138.081 40.0542Z"
            fill="black"
          />
          <path
            d="M91.3784 41.5136L89.9189 41.5134V42.9728H91.3784L91.3784 41.5136Z"
            fill="black"
          />
          <path
            d="M94.2973 41.5134L92.8379 41.5136L92.8379 42.9728H94.2973V41.5134Z"
            fill="black"
          />
          <path
            d="M97.2163 41.5136L95.7568 41.5134V42.9728H97.2162L97.2163 41.5136Z"
            fill="black"
          />
          <path
            d="M98.6757 41.5136H97.2163L97.2162 42.9728H98.6757L98.6757 41.5136Z"
            fill="black"
          />
          <path
            d="M100.135 41.5136H98.6757L98.6757 42.9728H100.135L100.135 41.5136Z"
            fill="black"
          />
          <path
            d="M101.595 41.5136H100.135L100.135 42.9728H101.595L101.595 41.5136Z"
            fill="black"
          />
          <path
            d="M103.054 41.5134L101.595 41.5136L101.595 42.9728H103.054V41.5134Z"
            fill="black"
          />
          <path d="M110.351 41.5134H108.892V42.9728H110.351V41.5134Z" fill="black" />
          <path
            d="M111.811 41.5136L110.351 41.5134V42.9728H111.811L111.811 41.5136Z"
            fill="black"
          />
          <path d="M113.27 41.5136H111.811L111.811 42.9728H113.27L113.27 41.5136Z" fill="black" />
          <path
            d="M117.649 41.5136H116.189L116.189 42.9728H117.649L117.649 41.5136Z"
            fill="black"
          />
          <path
            d="M124.946 41.5136H123.487L123.487 42.9728H124.946L124.946 41.5136Z"
            fill="black"
          />
          <path
            d="M127.865 41.5136H126.405L126.405 42.9728H127.865L127.865 41.5136Z"
            fill="black"
          />
          <path
            d="M133.703 41.5136H132.243L132.243 42.9728H133.703L133.703 41.5136Z"
            fill="black"
          />
          <path
            d="M136.622 41.5136H135.162L135.162 42.9728H136.622L136.622 41.5136Z"
            fill="black"
          />
          <path
            d="M94.2973 42.9728H92.8379L92.8379 44.4325H94.2973L94.2973 42.9728Z"
            fill="black"
          />
          <path
            d="M97.2162 42.9728H95.7568L95.7568 44.4325H97.2163L97.2162 42.9728Z"
            fill="black"
          />
          <path
            d="M101.595 42.9728H100.135L100.135 44.4325H101.595L101.595 42.9728Z"
            fill="black"
          />
          <path d="M105.973 42.9731H104.514V44.4325H105.973V42.9731Z" fill="black" />
          <path
            d="M108.892 42.9728L107.433 42.9731V44.4325H108.892L108.892 42.9728Z"
            fill="black"
          />
          <path
            d="M110.351 42.9728H108.892L108.892 44.4325H110.351L110.351 42.9728Z"
            fill="black"
          />
          <path d="M114.73 42.9731L113.27 42.9728L113.27 44.4325H114.73V42.9731Z" fill="black" />
          <path
            d="M119.108 42.9731L117.649 42.9728L117.649 44.4325H119.108V42.9731Z"
            fill="black"
          />
          <path d="M120.567 42.9731H119.108V44.4325H120.567V42.9731Z" fill="black" />
          <path
            d="M123.487 42.9728L122.027 42.9731V44.4325H123.487L123.487 42.9728Z"
            fill="black"
          />
          <path
            d="M126.405 42.9728H124.946L124.946 44.4325H126.405L126.405 42.9728Z"
            fill="black"
          />
          <path
            d="M127.865 42.9728H126.405L126.405 44.4325H127.865L127.865 42.9728Z"
            fill="black"
          />
          <path
            d="M129.324 42.9731L127.865 42.9728L127.865 44.4325H129.324V42.9731Z"
            fill="black"
          />
          <path d="M91.3784 44.4323H89.9189V45.8918H91.3784V44.4323Z" fill="black" />
          <path d="M94.2973 44.4325H92.8379V45.8918H94.2973V44.4325Z" fill="black" />
          <path d="M95.7568 44.4325H94.2973V45.8918H95.7568L95.7568 44.4325Z" fill="black" />
          <path
            d="M100.135 44.4325L98.6757 44.4323V45.8918H100.135L100.135 44.4325Z"
            fill="black"
          />
          <path
            d="M103.054 44.4323L101.595 44.4325L101.595 45.8918H103.054V44.4323Z"
            fill="black"
          />
          <path d="M105.973 44.4325H104.514V45.8918H105.973V44.4325Z" fill="black" />
          <path d="M108.892 44.4325H107.433V45.8918H108.892V44.4325Z" fill="black" />
          <path d="M110.351 44.4325H108.892V45.8918H110.351V44.4325Z" fill="black" />
          <path d="M114.73 44.4325H113.27V45.8918H114.73V44.4325Z" fill="black" />
          <path d="M123.487 44.4325H122.027V45.8918H123.487V44.4325Z" fill="black" />
          <path d="M124.946 44.4325H123.487V45.8918H124.946L124.946 44.4325Z" fill="black" />
          <path d="M126.405 44.4325H124.946L124.946 45.8918H126.405V44.4325Z" fill="black" />
          <path d="M129.324 44.4325H127.865L127.865 45.8918H129.324V44.4325Z" fill="black" />
          <path d="M130.784 44.4323L129.324 44.4325V45.8918H130.784V44.4323Z" fill="black" />
          <path d="M133.703 44.4323H132.243V45.8918H133.703V44.4323Z" fill="black" />
          <path d="M138.081 44.4323H136.622V45.8918H138.081V44.4323Z" fill="black" />
          <path d="M91.3784 45.8918H89.9189V47.3514H91.3784V45.8918Z" fill="black" />
          <path
            d="M94.2973 45.8918H92.8379L92.8379 47.3514H94.2973L94.2973 45.8918Z"
            fill="black"
          />
          <path
            d="M95.7568 45.8918H94.2973L94.2973 47.3514H95.7568L95.7568 45.8918Z"
            fill="black"
          />
          <path d="M97.2162 45.892L95.7568 45.8918L95.7568 47.3514H97.2162V45.892Z" fill="black" />
          <path d="M98.6757 45.8918L97.2162 45.892V47.3514H98.6757L98.6757 45.8918Z" fill="black" />
          <path
            d="M101.595 45.8918H100.135L100.135 47.3514H101.595L101.595 45.8918Z"
            fill="black"
          />
          <path
            d="M105.973 45.8918H104.514L104.514 47.3514H105.973L105.973 45.8918Z"
            fill="black"
          />
          <path
            d="M107.433 45.8918H105.973L105.973 47.3514H107.432L107.433 45.8918Z"
            fill="black"
          />
          <path d="M111.811 45.892L110.351 45.8918L110.351 47.3514H111.811V45.892Z" fill="black" />
          <path d="M116.189 45.892L114.73 45.8918L114.73 47.3514H116.189V45.892Z" fill="black" />
          <path d="M117.649 45.892H116.189V47.3514H117.649V45.892Z" fill="black" />
          <path d="M119.108 45.892H117.649V47.3514H119.108V45.892Z" fill="black" />
          <path d="M120.568 45.892H119.108V47.3514H120.568V45.892Z" fill="black" />
          <path
            d="M126.405 45.8918H124.946L124.946 47.3514H126.405L126.405 45.8918Z"
            fill="black"
          />
          <path
            d="M127.865 45.8918H126.405L126.405 47.3514H127.865L127.865 45.8918Z"
            fill="black"
          />
          <path
            d="M130.784 45.8918H129.324L129.324 47.3514H130.784L130.784 45.8918Z"
            fill="black"
          />
          <path d="M135.162 45.892L133.703 45.8918L133.703 47.3514H135.162V45.892Z" fill="black" />
          <path
            d="M94.2973 47.3514H92.8379L92.8379 48.8111H94.2973L94.2973 47.3514Z"
            fill="black"
          />
          <path
            d="M97.2162 47.3514H95.7568L95.7568 48.8111H97.2163L97.2162 47.3514Z"
            fill="black"
          />
          <path
            d="M98.6757 47.3514H97.2162L97.2163 48.8111H98.6757L98.6757 47.3514Z"
            fill="black"
          />
          <path
            d="M100.135 47.3514H98.6757L98.6757 48.8111H100.135L100.135 47.3514Z"
            fill="black"
          />
          <path
            d="M105.973 47.3514H104.514L104.514 48.8111H105.973L105.973 47.3514Z"
            fill="black"
          />
          <path
            d="M107.432 47.3514H105.973L105.973 48.8111H107.433L107.432 47.3514Z"
            fill="black"
          />
          <path
            d="M108.892 47.3517L107.432 47.3514L107.433 48.8111H108.892V47.3517Z"
            fill="black"
          />
          <path
            d="M111.811 47.3514H110.351L110.351 48.8111H111.811L111.811 47.3514Z"
            fill="black"
          />
          <path d="M113.27 47.3517L111.811 47.3514L111.811 48.8111H113.27V47.3517Z" fill="black" />
          <path d="M116.189 47.3514H114.73L114.73 48.8111H116.189L116.189 47.3514Z" fill="black" />
          <path
            d="M117.649 47.3514H116.189L116.189 48.8111H117.649L117.649 47.3514Z"
            fill="black"
          />
          <path
            d="M120.568 47.3514H119.108L119.108 48.8111H120.567L120.568 47.3514Z"
            fill="black"
          />
          <path
            d="M122.027 47.3517L120.568 47.3514L120.567 48.8111H122.027V47.3517Z"
            fill="black"
          />
          <path
            d="M124.946 47.3514L123.486 47.3517V48.8111H124.946L124.946 47.3514Z"
            fill="black"
          />
          <path
            d="M126.405 47.3514H124.946L124.946 48.8111H126.405L126.405 47.3514Z"
            fill="black"
          />
          <path
            d="M127.865 47.3514H126.405L126.405 48.8111H127.865L127.865 47.3514Z"
            fill="black"
          />
          <path
            d="M129.324 47.3514H127.865L127.865 48.8111H129.324L129.324 47.3514Z"
            fill="black"
          />
          <path
            d="M132.243 47.3517L130.784 47.3514L130.784 48.8111H132.243V47.3517Z"
            fill="black"
          />
          <path
            d="M136.622 47.3517L135.162 47.3514L135.162 48.8111H136.622V47.3517Z"
            fill="black"
          />
          <path d="M91.3784 48.8109H89.9189V50.2704H91.3784V48.8109Z" fill="black" />
          <path
            d="M92.8379 48.8111L91.3784 48.8109V50.2704H92.8379L92.8379 48.8111Z"
            fill="black"
          />
          <path d="M94.2973 48.8111H92.8379L92.8379 50.2704H94.2973V48.8111Z" fill="black" />
          <path d="M95.7568 48.8111H94.2973V50.2704H95.7568L95.7568 48.8111Z" fill="black" />
          <path d="M97.2163 48.8111H95.7568L95.7568 50.2704H97.2163V48.8111Z" fill="black" />
          <path
            d="M101.595 48.8109L100.135 48.8111L100.135 50.2704H101.595V48.8109Z"
            fill="black"
          />
          <path d="M105.973 48.8111H104.514V50.2704H105.973V48.8111Z" fill="black" />
          <path d="M107.433 48.8111H105.973V50.2704H107.433V48.8111Z" fill="black" />
          <path
            d="M110.351 48.8111H108.892L108.892 50.2704H110.351L110.351 48.8111Z"
            fill="black"
          />
          <path d="M111.811 48.8111H110.351L110.351 50.2704H111.811V48.8111Z" fill="black" />
          <path d="M113.27 48.8111H111.811V50.2704H113.27V48.8111Z" fill="black" />
          <path d="M114.73 48.8111H113.27V50.2704H114.73L114.73 48.8111Z" fill="black" />
          <path d="M116.189 48.8111H114.73L114.73 50.2704H116.189V48.8111Z" fill="black" />
          <path d="M117.649 48.8111H116.189V50.2704H117.649V48.8111Z" fill="black" />
          <path d="M122.027 48.8111H120.567L120.568 50.2704H122.027V48.8111Z" fill="black" />
          <path d="M124.946 48.8111H123.486V50.2704H124.946V48.8111Z" fill="black" />
          <path d="M127.865 48.8111H126.405L126.405 50.2704H127.865V48.8111Z" fill="black" />
          <path d="M129.324 48.8111H127.865V50.2704H129.324V48.8111Z" fill="black" />
          <path d="M130.784 48.8111H129.324V50.2704H130.784L130.784 48.8111Z" fill="black" />
          <path d="M91.3784 50.2704H89.9189V51.7295H91.3784V50.2704Z" fill="black" />
          <path d="M92.8379 50.2704H91.3784V51.7295H92.8379L92.8379 50.2704Z" fill="black" />
          <path
            d="M95.7568 50.2704H94.2973L94.2973 51.7295H95.7568L95.7568 50.2704Z"
            fill="black"
          />
          <path
            d="M97.2163 50.2704H95.7568L95.7568 51.7295H97.2162L97.2163 50.2704Z"
            fill="black"
          />
          <path
            d="M98.6757 50.2701L97.2163 50.2704L97.2162 51.7295H98.6757V50.2701Z"
            fill="black"
          />
          <path
            d="M100.135 50.2704L98.6757 50.2701V51.7295H100.135L100.135 50.2704Z"
            fill="black"
          />
          <path
            d="M103.054 50.2701L101.595 50.2704L101.595 51.7295H103.054V50.2701Z"
            fill="black"
          />
          <path
            d="M104.514 50.2704L103.054 50.2701V51.7295H104.514L104.514 50.2704Z"
            fill="black"
          />
          <path
            d="M108.892 50.2704H107.433L107.432 51.7295H108.892L108.892 50.2704Z"
            fill="black"
          />
          <path d="M116.189 50.2704H114.73L114.73 51.7295H116.189L116.189 50.2704Z" fill="black" />
          <path
            d="M117.649 50.2704H116.189L116.189 51.7295H117.649L117.649 50.2704Z"
            fill="black"
          />
          <path
            d="M119.108 50.2701L117.649 50.2704L117.649 51.7295H119.108V50.2701Z"
            fill="black"
          />
          <path
            d="M120.568 50.2704L119.108 50.2701V51.7295H120.568L120.568 50.2704Z"
            fill="black"
          />
          <path
            d="M122.027 50.2704H120.568L120.568 51.7295H122.027L122.027 50.2704Z"
            fill="black"
          />
          <path
            d="M123.486 50.2704H122.027L122.027 51.7295H123.487L123.486 50.2704Z"
            fill="black"
          />
          <path
            d="M126.405 50.2704H124.946L124.946 51.7295H126.405L126.405 50.2704Z"
            fill="black"
          />
          <path
            d="M129.324 50.2704H127.865L127.865 51.7295H129.324L129.324 50.2704Z"
            fill="black"
          />
          <path
            d="M132.243 50.2701L130.784 50.2704L130.784 51.7295H132.243V50.2701Z"
            fill="black"
          />
          <path d="M133.703 50.2701H132.243V51.7295H133.703V50.2701Z" fill="black" />
          <path d="M136.622 50.2701H135.162V51.7295H136.622V50.2701Z" fill="black" />
          <path d="M91.3784 51.7295H89.9189V53.1889H91.3784V51.7295Z" fill="black" />
          <path d="M92.8379 51.7295H91.3784V53.1889H92.8379L92.8379 51.7295Z" fill="black" />
          <path
            d="M97.2162 51.7295H95.7568L95.7568 53.1889H97.2163L97.2162 51.7295Z"
            fill="black"
          />
          <path
            d="M98.6757 51.7295H97.2162L97.2163 53.1889H98.6757L98.6757 51.7295Z"
            fill="black"
          />
          <path
            d="M101.595 51.7295H100.135L100.135 53.1889H101.595L101.595 51.7295Z"
            fill="black"
          />
          <path
            d="M103.054 51.7295H101.595L101.595 53.1889H103.054L103.054 51.7295Z"
            fill="black"
          />
          <path
            d="M104.514 51.7295H103.054L103.054 53.1889H104.514L104.514 51.7295Z"
            fill="black"
          />
          <path
            d="M105.973 51.7294L104.514 51.7295L104.514 53.1889H105.973V51.7294Z"
            fill="black"
          />
          <path d="M113.27 51.7294H111.811V53.1889H113.27V51.7294Z" fill="black" />
          <path d="M114.73 51.7295L113.27 51.7294V53.1889H114.73L114.73 51.7295Z" fill="black" />
          <path
            d="M117.649 51.7295H116.189L116.189 53.1889H117.649L117.649 51.7295Z"
            fill="black"
          />
          <path
            d="M120.568 51.7295H119.108L119.108 53.1889H120.567L120.568 51.7295Z"
            fill="black"
          />
          <path
            d="M123.487 51.7295H122.027L122.027 53.1889H123.487L123.487 51.7295Z"
            fill="black"
          />
          <path
            d="M124.946 51.7295H123.487L123.487 53.1889H124.946L124.946 51.7295Z"
            fill="black"
          />
          <path
            d="M126.405 51.7295H124.946L124.946 53.1889H126.405L126.405 51.7295Z"
            fill="black"
          />
          <path
            d="M133.703 51.7295H132.243L132.243 53.1889H133.703L133.703 51.7295Z"
            fill="black"
          />
          <path
            d="M135.162 51.7295H133.703L133.703 53.1889H135.162L135.162 51.7295Z"
            fill="black"
          />
          <path
            d="M136.622 51.7295H135.162L135.162 53.1889H136.622L136.622 51.7295Z"
            fill="black"
          />
          <path d="M91.3784 53.1889H89.9189V54.6486H91.3784V53.1889Z" fill="black" />
          <path
            d="M94.2973 53.1892L92.8379 53.1889L92.8379 54.6486H94.2973V53.1892Z"
            fill="black"
          />
          <path
            d="M95.7568 53.1889L94.2973 53.1892V54.6486H95.7568L95.7568 53.1889Z"
            fill="black"
          />
          <path
            d="M97.2163 53.1889H95.7568L95.7568 54.6486H97.2162L97.2163 53.1889Z"
            fill="black"
          />
          <path
            d="M100.135 53.1889H98.6757L98.6757 54.6486H100.135L100.135 53.1889Z"
            fill="black"
          />
          <path
            d="M101.595 53.1889H100.135L100.135 54.6486H101.595L101.595 53.1889Z"
            fill="black"
          />
          <path
            d="M105.973 53.1889H104.514L104.514 54.6486H105.973L105.973 53.1889Z"
            fill="black"
          />
          <path d="M108.892 53.1892H107.432V54.6486H108.892V53.1892Z" fill="black" />
          <path d="M110.351 53.1892H108.892V54.6486H110.351V53.1892Z" fill="black" />
          <path d="M113.27 53.1889H111.811L111.811 54.6486H113.27L113.27 53.1889Z" fill="black" />
          <path d="M114.73 53.1889H113.27L113.27 54.6486H114.73L114.73 53.1889Z" fill="black" />
          <path d="M116.189 53.1889H114.73L114.73 54.6486H116.189L116.189 53.1889Z" fill="black" />
          <path
            d="M120.567 53.1889H119.108L119.108 54.6486H120.568L120.567 53.1889Z"
            fill="black"
          />
          <path
            d="M122.027 53.1889H120.567L120.568 54.6486H122.027L122.027 53.1889Z"
            fill="black"
          />
          <path
            d="M123.487 53.1889H122.027L122.027 54.6486H123.487L123.487 53.1889Z"
            fill="black"
          />
          <path
            d="M124.946 53.1889H123.487L123.487 54.6486H124.946L124.946 53.1889Z"
            fill="black"
          />
          <path
            d="M126.405 53.1889H124.946L124.946 54.6486H126.405L126.405 53.1889Z"
            fill="black"
          />
          <path
            d="M127.865 53.1892L126.405 53.1889L126.405 54.6486H127.865V53.1892Z"
            fill="black"
          />
          <path d="M130.784 53.1892H129.324V54.6486H130.784V53.1892Z" fill="black" />
          <path
            d="M133.703 53.1889H132.243L132.243 54.6486H133.703L133.703 53.1889Z"
            fill="black"
          />
          <path
            d="M136.622 53.1889H135.162L135.162 54.6486H136.622L136.622 53.1889Z"
            fill="black"
          />
          <path
            d="M92.8379 54.6486H91.3784L91.3784 56.1082H92.8379L92.8379 54.6486Z"
            fill="black"
          />
          <path d="M94.2973 54.6486H92.8379L92.8379 56.1082H94.2973V54.6486Z" fill="black" />
          <path d="M97.2162 54.6486H95.7568L95.7568 56.1082H97.2162V54.6486Z" fill="black" />
          <path d="M101.595 54.6486H100.135L100.135 56.1082H101.595V54.6486Z" fill="black" />
          <path d="M105.973 54.6486H104.514V56.1082H105.973V54.6486Z" fill="black" />
          <path d="M108.892 54.6486H107.432V56.1082H108.892V54.6486Z" fill="black" />
          <path d="M110.351 54.6486H108.892V56.1082H110.351V54.6486Z" fill="black" />
          <path d="M113.27 54.6486H111.811V56.1082H113.27V54.6486Z" fill="black" />
          <path d="M116.189 54.6486H114.73L114.73 56.1082H116.189V54.6486Z" fill="black" />
          <path d="M117.649 54.6487L116.189 54.6486V56.1082H117.649V54.6487Z" fill="black" />
          <path d="M120.568 54.6486H119.108V56.1082H120.568V54.6486Z" fill="black" />
          <path d="M122.027 54.6486H120.568V56.1082H122.027V54.6486Z" fill="black" />
          <path d="M126.405 54.6486H124.946L124.946 56.1082H126.405V54.6486Z" fill="black" />
          <path d="M127.865 54.6486H126.405V56.1082H127.865V54.6486Z" fill="black" />
          <path d="M129.324 54.6486H127.865V56.1082H129.324L129.324 54.6486Z" fill="black" />
          <path d="M130.784 54.6486H129.324L129.324 56.1082H130.784V54.6486Z" fill="black" />
          <path d="M136.622 54.6486H135.162V56.1082H136.622V54.6486Z" fill="black" />
          <path
            d="M91.3784 56.1082L89.9189 56.1085V57.5679H91.3784L91.3784 56.1082Z"
            fill="black"
          />
          <path
            d="M94.2973 56.1082H92.8379L92.8379 57.5679H94.2973L94.2973 56.1082Z"
            fill="black"
          />
          <path
            d="M98.6757 56.1085L97.2162 56.1082L97.2163 57.5679H98.6757V56.1085Z"
            fill="black"
          />
          <path
            d="M100.135 56.1082L98.6757 56.1085V57.5679H100.135L100.135 56.1082Z"
            fill="black"
          />
          <path
            d="M101.595 56.1082H100.135L100.135 57.5679H101.595L101.595 56.1082Z"
            fill="black"
          />
          <path
            d="M104.514 56.1082L103.054 56.1085V57.5679H104.514L104.514 56.1082Z"
            fill="black"
          />
          <path
            d="M107.432 56.1082H105.973L105.973 57.5679H107.433L107.432 56.1082Z"
            fill="black"
          />
          <path
            d="M110.351 56.1082H108.892L108.892 57.5679H110.351L110.351 56.1082Z"
            fill="black"
          />
          <path
            d="M111.811 56.1082H110.351L110.351 57.5679H111.811L111.811 56.1082Z"
            fill="black"
          />
          <path
            d="M117.649 56.1082H116.189L116.189 57.5679H117.649L117.649 56.1082Z"
            fill="black"
          />
          <path
            d="M119.108 56.1082H117.649L117.649 57.5679H119.108L119.108 56.1082Z"
            fill="black"
          />
          <path
            d="M120.568 56.1082H119.108L119.108 57.5679H120.567L120.568 56.1082Z"
            fill="black"
          />
          <path
            d="M129.324 56.1082H127.865L127.865 57.5679H129.324L129.324 56.1082Z"
            fill="black"
          />
          <path
            d="M130.784 56.1082H129.324L129.324 57.5679H130.784L130.784 56.1082Z"
            fill="black"
          />
          <path
            d="M132.243 56.1085L130.784 56.1082L130.784 57.5679H132.243V56.1085Z"
            fill="black"
          />
          <path d="M133.703 56.1085H132.243V57.5679H133.703V56.1085Z" fill="black" />
          <path d="M91.3784 57.5679H89.9189V59.0273H91.3784V57.5679Z" fill="black" />
          <path
            d="M95.7568 57.5678L94.2973 57.5679L94.2973 59.0273H95.7568V57.5678Z"
            fill="black"
          />
          <path
            d="M98.6757 57.5679H97.2163L97.2162 59.0273H98.6757L98.6757 57.5679Z"
            fill="black"
          />
          <path
            d="M108.892 57.5679H107.433L107.432 59.0273H108.892L108.892 57.5679Z"
            fill="black"
          />
          <path d="M114.73 57.5678H113.27V59.0273H114.73V57.5678Z" fill="black" />
          <path d="M116.189 57.5679L114.73 57.5678V59.0273H116.189L116.189 57.5679Z" fill="black" />
          <path
            d="M119.108 57.5679H117.649L117.649 59.0273H119.108L119.108 57.5679Z"
            fill="black"
          />
          <path d="M123.487 57.5678H122.027V59.0273H123.487V57.5678Z" fill="black" />
          <path
            d="M129.324 57.5679H127.865L127.865 59.0273H129.324L129.324 57.5679Z"
            fill="black"
          />
          <path
            d="M133.703 57.5679H132.243L132.243 59.0273H133.703L133.703 57.5679Z"
            fill="black"
          />
          <path
            d="M135.162 57.5678L133.703 57.5679L133.703 59.0273H135.162V57.5678Z"
            fill="black"
          />
          <path d="M136.622 57.5678H135.162V59.0273H136.622V57.5678Z" fill="black" />
          <path
            d="M97.2162 59.0273H95.7568L95.7568 60.4864H97.2163L97.2162 59.0273Z"
            fill="black"
          />
          <path
            d="M98.6757 59.0273H97.2162L97.2163 60.4864H98.6757L98.6757 59.0273Z"
            fill="black"
          />
          <path d="M100.135 59.027L98.6757 59.0273L98.6757 60.4864H100.135V59.027Z" fill="black" />
          <path d="M101.595 59.027H100.135V60.4864H101.595V59.027Z" fill="black" />
          <path d="M107.432 59.0273L105.973 59.027V60.4864H107.433L107.432 59.0273Z" fill="black" />
          <path
            d="M108.892 59.0273H107.432L107.433 60.4864H108.892L108.892 59.0273Z"
            fill="black"
          />
          <path d="M111.811 59.027H110.351V60.4864H111.811V59.027Z" fill="black" />
          <path d="M114.73 59.0273H113.27L113.27 60.4864H114.73L114.73 59.0273Z" fill="black" />
          <path
            d="M117.649 59.0273H116.189L116.189 60.4864H117.649L117.649 59.0273Z"
            fill="black"
          />
          <path
            d="M119.108 59.0273H117.649L117.649 60.4864H119.108L119.108 59.0273Z"
            fill="black"
          />
          <path d="M122.027 59.0273L120.568 59.027V60.4864H122.027L122.027 59.0273Z" fill="black" />
          <path d="M124.946 59.027L123.487 59.0273L123.486 60.4864H124.946V59.027Z" fill="black" />
          <path d="M126.405 59.027H124.946V60.4864H126.405V59.027Z" fill="black" />
          <path d="M127.865 59.0273L126.405 59.027V60.4864H127.865L127.865 59.0273Z" fill="black" />
          <path
            d="M135.162 59.0273H133.703L133.703 60.4864H135.162L135.162 59.0273Z"
            fill="black"
          />
          <path
            d="M136.622 59.0273H135.162L135.162 60.4864H136.622L136.622 59.0273Z"
            fill="black"
          />
          <path
            d="M95.7568 60.4864L94.2973 60.4862V61.9457H95.7568L95.7568 60.4864Z"
            fill="black"
          />
          <path d="M97.2163 60.4864H95.7568L95.7568 61.9457H97.2163V60.4864Z" fill="black" />
          <path d="M98.6757 60.4864H97.2163V61.9457H98.6757V60.4864Z" fill="black" />
          <path d="M101.595 60.4864H100.135L100.135 61.9457H101.595V60.4864Z" fill="black" />
          <path d="M103.054 60.4862L101.595 60.4864V61.9457H103.054V60.4862Z" fill="black" />
          <path
            d="M105.973 60.4864L104.514 60.4862V61.9457H105.973L105.973 60.4864Z"
            fill="black"
          />
          <path
            d="M110.351 60.4864H108.892L108.892 61.9457H110.351L110.351 60.4864Z"
            fill="black"
          />
          <path d="M116.189 60.4864H114.73L114.73 61.9457H116.189L116.189 60.4864Z" fill="black" />
          <path d="M117.649 60.4864H116.189L116.189 61.9457H117.649V60.4864Z" fill="black" />
          <path d="M119.108 60.4864H117.649V61.9457H119.108V60.4864Z" fill="black" />
          <path d="M120.568 60.4864H119.108V61.9457H120.567L120.568 60.4864Z" fill="black" />
          <path d="M122.027 60.4864H120.568L120.567 61.9457H122.027V60.4864Z" fill="black" />
          <path d="M123.486 60.4864H122.027V61.9457H123.487L123.486 60.4864Z" fill="black" />
          <path d="M127.865 60.4864H126.405L126.405 61.9457H127.865V60.4864Z" fill="black" />
          <path d="M129.324 60.4862L127.865 60.4864V61.9457H129.324V60.4862Z" fill="black" />
          <path d="M132.243 60.4862H130.784V61.9457H132.243V60.4862Z" fill="black" />
          <path d="M133.703 60.4864L132.243 60.4862V61.9457H133.703V60.4864Z" fill="black" />
          <path d="M136.622 60.4864H135.162L135.162 61.9457H136.622V60.4864Z" fill="black" />
          <path d="M138.081 60.4862L136.622 60.4864V61.9457H138.081V60.4862Z" fill="black" />
          <path d="M91.3784 61.9459H89.9189V63.4054H91.3784V61.9459Z" fill="black" />
          <path d="M92.8379 61.9459H91.3784V63.4054H92.8379V61.9459Z" fill="black" />
          <path
            d="M94.2973 61.9457L92.8379 61.9459V63.4054H94.2973L94.2973 61.9457Z"
            fill="black"
          />
          <path
            d="M97.2163 61.9457H95.7568L95.7568 63.4054H97.2162L97.2163 61.9457Z"
            fill="black"
          />
          <path
            d="M100.135 61.9457H98.6757L98.6757 63.4054H100.135L100.135 61.9457Z"
            fill="black"
          />
          <path
            d="M101.595 61.9457H100.135L100.135 63.4054H101.595L101.595 61.9457Z"
            fill="black"
          />
          <path
            d="M105.973 61.9457H104.514L104.514 63.4054H105.973L105.973 61.9457Z"
            fill="black"
          />
          <path
            d="M107.432 61.9459L105.973 61.9457L105.973 63.4054H107.432V61.9459Z"
            fill="black"
          />
          <path
            d="M110.351 61.9457H108.892L108.892 63.4054H110.351L110.351 61.9457Z"
            fill="black"
          />
          <path
            d="M111.811 61.9459L110.351 61.9457L110.351 63.4054H111.811V61.9459Z"
            fill="black"
          />
          <path d="M113.27 61.9459H111.811V63.4054H113.27V61.9459Z" fill="black" />
          <path d="M114.73 61.9457L113.27 61.9459V63.4054H114.73L114.73 61.9457Z" fill="black" />
          <path d="M116.189 61.9457H114.73L114.73 63.4054H116.189L116.189 61.9457Z" fill="black" />
          <path
            d="M120.567 61.9457H119.108L119.108 63.4054H120.568L120.567 61.9457Z"
            fill="black"
          />
          <path
            d="M122.027 61.9457H120.567L120.568 63.4054H122.027L122.027 61.9457Z"
            fill="black"
          />
          <path
            d="M123.487 61.9457H122.027L122.027 63.4054H123.487L123.487 61.9457Z"
            fill="black"
          />
          <path
            d="M126.405 61.9457L124.946 61.9459V63.4054H126.405L126.405 61.9457Z"
            fill="black"
          />
          <path
            d="M127.865 61.9457H126.405L126.405 63.4054H127.865L127.865 61.9457Z"
            fill="black"
          />
          <path
            d="M129.324 61.9457H127.865L127.865 63.4054H129.324L129.324 61.9457Z"
            fill="black"
          />
          <path
            d="M130.784 61.9457H129.324L129.324 63.4054H130.784L130.784 61.9457Z"
            fill="black"
          />
          <path
            d="M132.243 61.9457H130.784L130.784 63.4054H132.243L132.243 61.9457Z"
            fill="black"
          />
          <path
            d="M133.703 61.9457H132.243L132.243 63.4054H133.703L133.703 61.9457Z"
            fill="black"
          />
          <path
            d="M136.622 61.9457H135.162L135.162 63.4054H136.622L136.622 61.9457Z"
            fill="black"
          />
          <path d="M103.054 63.4056L101.595 63.4054L101.595 64.865H103.054V63.4056Z" fill="black" />
          <path d="M105.973 63.4054H104.514L104.514 64.865H105.973L105.973 63.4054Z" fill="black" />
          <path d="M107.432 63.4054H105.973L105.973 64.865H107.433L107.432 63.4054Z" fill="black" />
          <path d="M110.351 63.4054H108.892L108.892 64.865H110.351L110.351 63.4054Z" fill="black" />
          <path d="M111.811 63.4054H110.351L110.351 64.865H111.811L111.811 63.4054Z" fill="black" />
          <path d="M113.27 63.4054H111.811L111.811 64.865H113.27L113.27 63.4054Z" fill="black" />
          <path d="M114.73 63.4054H113.27L113.27 64.865H114.73L114.73 63.4054Z" fill="black" />
          <path d="M116.189 63.4054H114.73L114.73 64.865H116.189L116.189 63.4054Z" fill="black" />
          <path d="M122.027 63.4054H120.568L120.568 64.865H122.027L122.027 63.4054Z" fill="black" />
          <path d="M123.487 63.4054H122.027L122.027 64.865H123.487L123.487 63.4054Z" fill="black" />
          <path d="M124.946 63.4054H123.487L123.487 64.865H124.946L124.946 63.4054Z" fill="black" />
          <path d="M126.405 63.4054H124.946L124.946 64.865H126.405L126.405 63.4054Z" fill="black" />
          <path d="M132.243 63.4054H130.784L130.784 64.865H132.243L132.243 63.4054Z" fill="black" />
          <path d="M135.162 63.4054H133.703L133.703 64.865H135.162L135.162 63.4054Z" fill="black" />
          <path d="M103.054 64.865H101.595V66.3243H103.054V64.865Z" fill="black" />
          <path d="M104.514 64.865H103.054V66.3243H104.514L104.514 64.865Z" fill="black" />
          <path d="M105.973 64.865H104.514L104.514 66.3243H105.973V64.865Z" fill="black" />
          <path d="M111.811 64.865H110.351L110.351 66.3243H111.811V64.865Z" fill="black" />
          <path d="M113.27 64.865H111.811V66.3243H113.27V64.865Z" fill="black" />
          <path d="M117.649 64.8648L116.189 64.865L116.189 66.3243H117.649V64.8648Z" fill="black" />
          <path d="M126.405 64.865H124.946L124.946 66.3243H126.405V64.865Z" fill="black" />
          <path d="M129.324 64.8648H127.865V66.3243H129.324V64.8648Z" fill="black" />
          <path d="M132.243 64.865H130.784V66.3243H132.243V64.865Z" fill="black" />
          <path d="M133.703 64.865H132.243V66.3243H133.703V64.865Z" fill="black" />
          <path d="M107.432 66.3246L105.973 66.3243L105.973 67.784H107.432V66.3246Z" fill="black" />
          <path d="M111.811 66.3243H110.351L110.351 67.784H111.811L111.811 66.3243Z" fill="black" />
          <path d="M113.27 66.3243H111.811L111.811 67.784H113.27L113.27 66.3243Z" fill="black" />
          <path d="M114.73 66.3246L113.27 66.3243L113.27 67.784H114.73V66.3246Z" fill="black" />
          <path d="M119.108 66.3246L117.649 66.3243L117.649 67.784H119.108V66.3246Z" fill="black" />
          <path d="M123.487 66.3246H122.027V67.784H123.487V66.3246Z" fill="black" />
          <path d="M126.405 66.3243H124.946L124.946 67.784H126.405L126.405 66.3243Z" fill="black" />
          <path d="M132.243 66.3243H130.784L130.784 67.784H132.243L132.243 66.3243Z" fill="black" />
          <path d="M138.081 66.3246H136.622V67.784H138.081V66.3246Z" fill="black" />
          <path d="M103.054 67.7838H101.595V69.2432H103.054V67.7838Z" fill="black" />
          <path d="M107.432 67.784H105.973L105.973 69.2432H107.433L107.432 67.784Z" fill="black" />
          <path d="M108.892 67.7838L107.432 67.784L107.433 69.2432H108.892V67.7838Z" fill="black" />
          <path d="M110.351 67.784L108.892 67.7838V69.2432H110.351L110.351 67.784Z" fill="black" />
          <path d="M111.811 67.784H110.351L110.351 69.2432H111.811L111.811 67.784Z" fill="black" />
          <path d="M114.73 67.784H113.27L113.27 69.2432H114.73L114.73 67.784Z" fill="black" />
          <path d="M119.108 67.784H117.649L117.649 69.2432H119.108L119.108 67.784Z" fill="black" />
          <path d="M123.487 67.784H122.027L122.027 69.2432H123.487L123.487 67.784Z" fill="black" />
          <path d="M126.405 67.784H124.946L124.946 69.2432H126.405L126.405 67.784Z" fill="black" />
          <path d="M127.865 67.7838L126.405 67.784L126.405 69.2432H127.865V67.7838Z" fill="black" />
          <path d="M129.324 67.7838H127.865V69.2432H129.324V67.7838Z" fill="black" />
          <path d="M130.784 67.784L129.324 67.7838V69.2432H130.784L130.784 67.784Z" fill="black" />
          <path d="M132.243 67.784H130.784L130.784 69.2432H132.243L132.243 67.784Z" fill="black" />
          <path d="M133.703 67.7838L132.243 67.784L132.243 69.2432H133.703V67.7838Z" fill="black" />
          <path d="M138.081 67.784H136.622L136.622 69.2432H138.081L138.081 67.784Z" fill="black" />
          <path
            d="M104.514 69.2431L103.054 69.2432L103.054 70.7026H104.514V69.2431Z"
            fill="black"
          />
          <path
            d="M105.973 69.2432L104.514 69.2431V70.7026H105.973L105.973 69.2432Z"
            fill="black"
          />
          <path
            d="M108.892 69.2432H107.433L107.432 70.7026H108.892L108.892 69.2432Z"
            fill="black"
          />
          <path
            d="M110.351 69.2432H108.892L108.892 70.7026H110.351L110.351 69.2432Z"
            fill="black"
          />
          <path
            d="M117.649 69.2432L116.189 69.2431V70.7026H117.649L117.649 69.2432Z"
            fill="black"
          />
          <path
            d="M119.108 69.2432H117.649L117.649 70.7026H119.108L119.108 69.2432Z"
            fill="black"
          />
          <path
            d="M120.568 69.2431L119.108 69.2432L119.108 70.7026H120.568V69.2431Z"
            fill="black"
          />
          <path
            d="M124.946 69.2432H123.487L123.487 70.7026H124.946L124.946 69.2432Z"
            fill="black"
          />
          <path
            d="M129.324 69.2432H127.865L127.865 70.7026H129.324L129.324 69.2432Z"
            fill="black"
          />
          <path
            d="M130.784 69.2432H129.324L129.324 70.7026H130.784L130.784 69.2432Z"
            fill="black"
          />
          <path
            d="M132.243 69.2432H130.784L130.784 70.7026H132.243L132.243 69.2432Z"
            fill="black"
          />
          <path
            d="M133.703 69.2432H132.243L132.243 70.7026H133.703L133.703 69.2432Z"
            fill="black"
          />
          <path
            d="M135.162 69.2431L133.703 69.2432L133.703 70.7026H135.162V69.2431Z"
            fill="black"
          />
          <path
            d="M136.622 69.2432L135.162 69.2431V70.7026H136.622L136.622 69.2432Z"
            fill="black"
          />
          <path d="M104.514 70.7026H103.054V72.1621H104.514V70.7026Z" fill="black" />
          <path d="M108.892 70.7026H107.432V72.1621H108.892V70.7026Z" fill="black" />
          <path
            d="M111.811 70.7027L110.351 70.7026L110.351 72.1621H111.811V70.7027Z"
            fill="black"
          />
          <path d="M113.27 70.7027H111.811V72.1621H113.27V70.7027Z" fill="black" />
          <path d="M117.649 70.7026H116.189V72.1621H117.649V70.7026Z" fill="black" />
          <path d="M120.568 70.7026H119.108L119.108 72.1621H120.568V70.7026Z" fill="black" />
          <path d="M122.027 70.7027L120.568 70.7026V72.1621H122.027V70.7027Z" fill="black" />
          <path
            d="M127.865 70.7026L126.405 70.7027V72.1621H127.865L127.865 70.7026Z"
            fill="black"
          />
          <path d="M129.324 70.7026H127.865L127.865 72.1621H129.324V70.7026Z" fill="black" />
          <path d="M130.784 70.7026H129.324V72.1621H130.784V70.7026Z" fill="black" />
          <path d="M132.243 70.7026H130.784V72.1621H132.243V70.7026Z" fill="black" />
          <path d="M133.703 70.7026H132.243V72.1621H133.703V70.7026Z" fill="black" />
          <path
            d="M107.432 72.1621L105.973 72.1624V73.6218H107.433L107.432 72.1621Z"
            fill="black"
          />
          <path
            d="M108.892 72.1621H107.432L107.433 73.6218H108.892L108.892 72.1621Z"
            fill="black"
          />
          <path
            d="M110.351 72.1621H108.892L108.892 73.6218H110.351L110.351 72.1621Z"
            fill="black"
          />
          <path d="M113.27 72.1621H111.811L111.811 73.6218H113.27L113.27 72.1621Z" fill="black" />
          <path d="M114.73 72.1624L113.27 72.1621L113.27 73.6218H114.73V72.1624Z" fill="black" />
          <path d="M116.189 72.1621L114.73 72.1624V73.6218H116.189L116.189 72.1621Z" fill="black" />
          <path
            d="M117.649 72.1621H116.189L116.189 73.6218H117.649L117.649 72.1621Z"
            fill="black"
          />
          <path
            d="M122.027 72.1621H120.568L120.568 73.6218H122.027L122.027 72.1621Z"
            fill="black"
          />
          <path d="M124.946 72.1624H123.486V73.6218H124.946V72.1624Z" fill="black" />
          <path
            d="M126.405 72.1621L124.946 72.1624V73.6218H126.405L126.405 72.1621Z"
            fill="black"
          />
          <path
            d="M129.324 72.1621H127.865L127.865 73.6218H129.324L129.324 72.1621Z"
            fill="black"
          />
          <path d="M103.054 73.6216H101.595V75.0811H103.054V73.6216Z" fill="black" />
          <path
            d="M105.973 73.6218L104.514 73.6216V75.0811H105.973L105.973 73.6218Z"
            fill="black"
          />
          <path d="M116.189 73.6218H114.73L114.73 75.0811H116.189V73.6218Z" fill="black" />
          <path
            d="M119.108 73.6216L117.649 73.6218L117.649 75.0811H119.108V73.6216Z"
            fill="black"
          />
          <path
            d="M120.568 73.6218L119.108 73.6216V75.0811H120.567L120.568 73.6218Z"
            fill="black"
          />
          <path d="M122.027 73.6218H120.568L120.567 75.0811H122.027V73.6218Z" fill="black" />
          <path d="M123.486 73.6218H122.027V75.0811H123.487L123.486 73.6218Z" fill="black" />
          <path d="M124.946 73.6218H123.486L123.487 75.0811H124.946V73.6218Z" fill="black" />
          <path d="M126.405 73.6218H124.946V75.0811H126.405V73.6218Z" fill="black" />
          <path d="M127.865 73.6218H126.405V75.0811H127.865L127.865 73.6218Z" fill="black" />
          <path d="M129.324 73.6218H127.865L127.865 75.0811H129.324V73.6218Z" fill="black" />
          <path d="M133.703 73.6216H132.243V75.0811H133.703V73.6216Z" fill="black" />
          <path d="M138.081 73.6216H136.622V75.0811H138.081V73.6216Z" fill="black" />
          <path
            d="M89.9189 26.9189V37.1352H100.135V26.9189H89.9189ZM98.6027 35.6027H91.4514V28.4514H98.6027V35.6027Z"
            fill="black"
          />
          <path
            d="M127.865 26.9189V37.1352H138.081V26.9189H127.865ZM136.549 35.6027H129.397V28.4514H136.549V35.6027Z"
            fill="black"
          />
          <path
            d="M89.9189 64.8648V75.081H100.135V64.8648H89.9189ZM98.6027 73.5486H91.4514V66.3973H98.6027V73.5486Z"
            fill="black"
          />
          <path d="M97.2162 29.838H92.8379V34.2164H97.2162V29.838Z" fill="black" />
          <path d="M135.162 29.838H130.784V34.2164H135.162V29.838Z" fill="black" />
          <path d="M97.2163 67.7838H92.8379V72.1621H97.2163V67.7838Z" fill="black" />
          <mask id="path-4-inside-1_1332_135" fill="white">
            <path d="M79 90C76.7909 90 75 88.2091 75 86V78H87V90H79Z" />
          </mask>
          <path
            d="M79 92C75.6863 92 73 89.3137 73 86V78H77V86C77 87.1046 77.8954 88 79 88V92ZM87 78V90V78ZM87 92H79C75.6863 92 73 89.3137 73 86H77C77 87.1046 77.8954 88 79 88H87V92ZM75 78H87H75Z"
            fill="#11C182"
            mask="url(#path-4-inside-1_1332_135)"
          />
          <mask id="path-6-inside-2_1332_135" fill="white">
            <path d="M149 90C151.209 90 153 88.2091 153 86V78H141V90H149Z" />
          </mask>
          <path
            d="M149 92C152.314 92 155 89.3137 155 86V78H151V86C151 87.1046 150.105 88 149 88V92ZM141 78V90V78ZM141 92H149C152.314 92 155 89.3137 155 86H151C151 87.1046 150.105 88 149 88H141V92ZM153 78H141H153Z"
            fill="#11C182"
            mask="url(#path-6-inside-2_1332_135)"
          />
          <mask id="path-8-inside-3_1332_135" fill="white">
            <path d="M75 16C75 13.7909 76.7909 12 79 12H87V24H75V16Z" />
          </mask>
          <path
            d="M73 16C73 12.6863 75.6863 10 79 10H87V14H79C77.8954 14 77 14.8954 77 16H73ZM87 24H75H87ZM73 24V16C73 12.6863 75.6863 10 79 10V14C77.8954 14 77 14.8954 77 16V24H73ZM87 12V24V12Z"
            fill="#11C182"
            mask="url(#path-8-inside-3_1332_135)"
          />
          <mask id="path-10-inside-4_1332_135" fill="white">
            <path d="M153 16C153 13.7909 151.209 12 149 12H141V24H153V16Z" />
          </mask>
          <path
            d="M155 16C155 12.6863 152.314 10 149 10H141V14H149C150.105 14 151 14.8954 151 16H155ZM141 24H153H141ZM155 24V16C155 12.6863 152.314 10 149 10V14C150.105 14 151 14.8954 151 16V24H155ZM141 12V24V12Z"
            fill="#11C182"
            mask="url(#path-10-inside-4_1332_135)"
          />
          <g clip-path="url(#clip1_1332_135)">
            <mask
              id="mask0_1332_135"
              style={{ "mask-type": "alpha" }}
              maskUnits="userSpaceOnUse"
              x="-98"
              y="49"
              width="424"
              height="14"
            >
              <rect
                width="424"
                height="14"
                transform="translate(-98 49)"
                fill="url(#paint0_radial_1332_135)"
              />
            </mask>
            <g mask="url(#mask0_1332_135)">
              <path opacity="0.1" d="M-98 49H326V63H-98V49Z" fill="#11C182" />
              <line x1="-98" y1="49" x2="326" y2="49" stroke="#11C182" stroke-width="2" />
            </g>
          </g>
        </g>
        <path
          d="M8 0.0498047H220C224.391 0.0498047 227.95 3.60934 227.95 8V94C227.95 98.3907 224.391 101.95 220 101.95H8C3.60934 101.95 0.0498047 98.3907 0.0498047 94V8C0.0498047 3.60934 3.60934 0.0498047 8 0.0498047Z"
          stroke="black"
          stroke-width="0.1"
        />
        <defs>
          <radialGradient
            id="paint0_radial_1332_135"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(212 -1.66893e-06) rotate(90) scale(14 221.301)"
          >
            <stop />
            <stop offset="0.953125" stop-opacity="0" />
          </radialGradient>
          <clipPath id="clip0_1332_135">
            <path
              d="M0 8C0 3.58172 3.58172 0 8 0H220C224.418 0 228 3.58172 228 8V94C228 98.4183 224.418 102 220 102H8C3.58172 102 0 98.4183 0 94V8Z"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip1_1332_135">
            <rect width="424" height="14" fill="white" transform="translate(-98 49)" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);

QRScan.displayName = "QRScan";

export default QRScan;
